/**
 * Insere placeholders no HTML do artigo após o fechamento do N-ésimo `<p>` (N = 1-based).
 */

export function insertParagraphSlotPlaceholders(htmlContent, slots) {
  if (!htmlContent || typeof htmlContent !== 'string' || !slots?.length) {
    return htmlContent;
  }

  const pTags = htmlContent.match(/<p[^>]*>[\s\S]*?<\/p>/gi) || [];
  const pCount = pTags.length;

  const getInsertionCharIndex = (afterParagraph) => {
    if (pCount === 0) {
      return htmlContent.length;
    }
    const n = Math.min(Math.max(Number(afterParagraph) || 1, 1), pCount);
    const tag = pTags[n - 1];
    const idx = htmlContent.indexOf(tag);
    if (idx === -1) {
      return htmlContent.length;
    }
    return idx + tag.length;
  };

  /** @type {Map<number, string>} */
  const indexToPlaceholderHtml = new Map();

  for (let i = 0; i < slots.length; i += 1) {
    const slot = slots[i];
    const id = normalizeArticleSlotId(slot.slotId, i);
    const idx = getInsertionCharIndex(slot.afterParagraph);
    const div = `<div id="${id}" class="article-paragraph-slot" data-article-slot="${id}"></div>`;
    indexToPlaceholderHtml.set(
      idx,
      (indexToPlaceholderHtml.get(idx) || '') + div
    );
  }

  const sortedIndices = [...indexToPlaceholderHtml.keys()].sort((a, b) => b - a);

  let result = htmlContent;
  for (const charIndex of sortedIndices) {
    const chunk = indexToPlaceholderHtml.get(charIndex) || '';
    result = result.slice(0, charIndex) + chunk + result.slice(charIndex);
  }

  return result;
}

export function normalizeArticleSlotId(raw, fallbackIndex = 0) {
  const cleaned = String(raw || '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-zA-Z0-9_-]/g, '');
  return cleaned || `article-slot-${fallbackIndex}`;
}
